import axiosPost from "./axiosPost";

export const RNHUnidadUpd = async (credentials, data) => {
    const body = {
        service: "RNHUnidadUpd",
        params: {
            rnhUnidadId: data?.id,
            rnhUnidadCod: data?.cod,
            rnhUnidadNombre: data?.name,
            rnhUnidadDescripcion: data?.desc,
            rnhUnidadVersion: data?.version,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
